import { render, staticRenderFns } from "./DisplayProducts.vue?vue&type=template&id=174accd6&scoped=true&"
import script from "./DisplayProducts.vue?vue&type=script&lang=js&"
export * from "./DisplayProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174accd6",
  null
  
)

export default component.exports